import { withIcon } from './withIcon'

export const Analytics = withIcon(() => (
  <>
    <path d="M16.5 0.5H12.3857V16.5H16.5V0.5Z" />
    <path d="M10.5571 4.5H6.44287V16.5H10.5571V4.5Z" />
    <path d="M4.61426 8.5H0.5V16.5H4.61426V8.5Z" />
  </>
))
